import { providers } from '@febos-io/design';

import useTranslation from '../hooks/useTranslation';

import ClinicSelector from '../components/ClinicSelector';

export default function ClinicSelectorPage() {
  const { AppLogo } = providers.useDesignContext();
  const { t } = useTranslation();

  return (
    <div id="empresas-selector">
      <div className="card-body mx-auto col-sm-10 offset-sm-2 col-lg-10 offset-lg-2 text-center">
        <div className="d-flex align-items-center">
          {AppLogo && <AppLogo className="me-2" />}
          <span className="fs-4 fw-semibold">
            {t('Select Clinic')}
          </span>
        </div>
      </div>
      <div className="pricing-card row">
        <div className="mx-auto col-sm-10 offset-sm-2 col-lg-10 offset-lg-2">
          <div className="row">
            <ClinicSelector />
          </div>
        </div>
      </div>
    </div>
  );
}
